/**
 * Lab profile snapshots are immutable per revision, and the Lab shows several revisions of
 * one profile at once (the current decision, older checks and histories). Keying them by id
 * alone would let a historical revision overwrite the profile a current decision used.
 */
export const LAB_OPERATING_PROFILE_POLICY = { keyFields: ['id', 'version'] };
